export default "__VITE_ASSET__9x5OVtGi__"